module.exports = __webpack_public_path__ + "static/media/heroimage.c10328f3.png";